import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

/** Marks a "Courtyards at/of/on …" community whose prefix the list has dropped. */
export const CourtyardsBadge: React.FC<{ testID?: string }> = ({ testID }) => (
	<View style={styles.badge} testID={testID} accessibilityLabel="Courtyards community">
		<Ionicons name="leaf-outline" size={12} color="#2e7d32" />
		<Text style={styles.text}>Courtyards</Text>
	</View>
);

const styles = StyleSheet.create({
	badge: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: 3,
		alignSelf: 'flex-start',
		backgroundColor: '#e8f5e9',
		borderRadius: 10,
		paddingHorizontal: 6,
		paddingVertical: 1,
	},
	text: { fontSize: 11, fontWeight: '600', color: '#2e7d32' },
});
